var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { to: _vm.link },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c(
        "v-list-item-avatar",
        [_c("v-icon", { attrs: { small: "" } }, [_vm._v(_vm._s(_vm.icon))])],
        1
      ),
      _c(
        "v-list-item-content",
        [_c("v-list-item-title", [_vm._v(_vm._s(_vm.text))])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }